import type { Theme } from '@mui/material';

export const style = {
  wrapper: (theme: Theme) => ({
    bgcolor: theme.colors.secondary[400],
    borderRadius: '50%',
    width: '1.75rem',
    height: '1.75rem',
    justifyContent: 'center',
    cursor: 'pointer',
  }),

  icon: (theme: Theme) => ({
    color: theme.colors.secondary[800],
    fill: 'transparent',
    ml: 0.5,
    height: '100%',
    width: 'auto',
  }),
};
